module.exports = __webpack_public_path__ + "media/images/front/event/service-icon-a6f223cc19fcf1dc5503e97d84020cd8.svg";